<script setup>
import { DatePickerGridBody } from 'reka-ui';

const props = defineProps({
    asChild: { type: Boolean, required: false },
    as: { type: null, required: false },
});
</script>

<template>
    <DatePickerGridBody v-bind="props">
        <slot />
    </DatePickerGridBody>
</template>
